//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import "swiper/css/swiper.css"; //引入swiper样式   
import Swiper from "swiper"; //引入swiper  
import swiperBottom from '../../components/swiper_bottom.vue'
import partTwo from '../../components/part_two.vue'
import partThree from '../../components/part_three.vue'
import partFour from '../../components/part_four.vue'
import partFive from '../../components/part_five.vue'
import partSix from '../../components/part_six.vue'
import partSeven from '../../components/part_seven.vue'
import partEight from '../../components/part_eight.vue'
import partNine from '../../components/part_nine.vue'
import indexDialog from '../../components/compPop/indexDialog'
export default {
  name:'',
  //import引入的组件需要注入到对象中才能使用
  components: {
    swiperBottom,
    partTwo,
    partThree,
    partFour,
    partFive,
    partSix,
    partSeven,
    partEight,
    partNine,
    indexDialog
  },
  data() {
  return {
     //轮播图   
     imgs: [
      { pic: require("../../assets/swiper3.png") },
      { pic: require("../../assets/swiper5.jpg"),url:'https://www.yunzmall.com/plugins/shop_server/articleContent/606?i=10' },
      { pic: require("../../assets/swiper4.jpg"),url:'https://www.yunzmall.com/plugins/shop_server/articleContent/581?i=10' },
      { pic: require("../../assets/swiper1.jpg"),url:'https://www.yunzmall.com/plugins/shop_server/articleContent/520?i=10' },
      { pic: require("../../assets/swiper2.jpg"),url:'https://www.yunzmall.com/plugins/shop_server/articleContent/561?i=10' },
    ],
    dialogVisible:false
  };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    imgClick(url){
      if(url){
         window.open(url)
      }
    },
    openDialog(){
      this.dialogVisible = true
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // var mySwiper = new Swiper("#swiperIndex", {


    //   loop: true, // 循环模式选项
    //   pagination: {
    //     el: ".swiper-pagination", //换页器与哪个标签关联  
    //     clickable: true, //分页器是否可以点击 
    //   },
    //   // 如果需要前进后退按钮
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    //   autoplay: {
    //     delay: 3000,
    //     stopOnLastSlide: false,
    //     disableOnInteraction: true,
    //   },
    // });

    // mySwiper.el.onmouseover = function () {
    //   //鼠标放上暂停轮播  
    //   mySwiper.autoplay.stop();
    // };
    // mySwiper.el.onmouseleave = function () {
    //   mySwiper.autoplay.start();
    // };
    const that = this
     setTimeout( () =>{
      that.dialogVisible = true;
     },15000)
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}